import {APIResponse} from "../services/HttpService";
import {ApiDefinition} from "./ApiDefinition";
import {UserDTO} from "./model/user/UserDTO";

type Locale = "en" | "lt" | "pl" | string;

class LangApiDefinition extends ApiDefinition{
    constructor() {
        super("/lang");
    }

    async getUserLangBundle(): Promise<APIResponse<any>> {
        return this.get("/lang.json");
    }

    async getUserLangBundleProperties(): Promise<APIResponse<any>> {
        return this.get("/lang.properties");
    }

    async getLanguageBundle(locale: Locale = "en"): Promise<APIResponse<UserDTO>> {
        return this.get(`lang-${locale}.json`);
    }

    async getLanguageBundleCombined(locale: Locale, companyRef: string): Promise<APIResponse<UserDTO>> {
        return this.get(`lang-combined/${companyRef}/${locale}.json`);
    }

    async getLangJson(locale: Locale): Promise<APIResponse<String>> {
        return this.get(`lang-${locale}.json`);
    }

    async getLanguageBundleProperties(locale: Locale): Promise<APIResponse<String>> {
        return this.get(`lang-${locale}.properties`);
    }
}

const LangApi = new LangApiDefinition();
export default LangApi;